export const ZONE_WIZARD_STEP_IDS = ["contenant", "materials", "managers"];

export const DEFAULT_ZONE_CREATE_FORM = {
  addressId: "",
  addressName: "",
  positioning: "",
  location: null,
  type: "unknown",
  volume: 0,
  volumeUnit: "m3",
  contentCategory: "",
  wasteName: "",
  contentCategoryJoin: { authorizedMaterial: [] },
  limitFillingLevel: 80,
  packmatActive: false,
  status: "drop_driver",
  alertForAnomaly: false,
  alertForFilling: false,
  addressDestinationId: "",
  contract_id: "",
  collectorEmail: "",
  displayColor: "#fff",
  activatedSortingErrorOption: false,
  activatedFillingLevelOption: false,
  characterization: false,
  qualicheck: false,
  showDepotCycle: false,
};

export function getWizardStepIndex(stepId, stepIds = ZONE_WIZARD_STEP_IDS) {
  const index = stepIds.indexOf(stepId);
  return index >= 0 ? index : 0;
}

/** Champs comparés pour détecter des modifications (création zone). */
export function normalizeZoneFormForDirtyCheck(data) {
  const safe = data || {};
  return {
    addressId: safe.addressId || "",
    addressName: safe.addressName || "",
    positioning: String(safe.positioning ?? "").trim(),
    type: safe.type || "unknown",
    volume: Number(safe.volume) || 0,
    contentCategory: safe.contentCategory || "",
    wasteName: safe.wasteName || "",
    limitFillingLevel: safe.limitFillingLevel ?? 80,
    packmatActive: !!safe.packmatActive,
    status: safe.status || "drop_driver",
    alertForAnomaly: !!safe.alertForAnomaly,
    alertForFilling: !!safe.alertForFilling,
    addressDestinationId: safe.addressDestinationId || "",
    contract_id: safe.contract_id || "",
    collectorEmail: safe.collectorEmail || "",
    activatedSortingErrorOption: !!safe.activatedSortingErrorOption,
    activatedFillingLevelOption: !!safe.activatedFillingLevelOption,
    characterization: !!safe.characterization,
    qualicheck: !!safe.qualicheck,
    showDepotCycle: !!safe.showDepotCycle,
  };
}

const isValidObjectId = (value) =>
  typeof value === "string" &&
  value.length === 24 &&
  /^[a-f0-9]{24}$/i.test(value);

/** Champs « unknown » / vides → null pour l’API update. */
export function prepareZoneUpdatePayload(formData) {
  const payload = { ...formData };

  const toObjectIdOrNull = (value) => (isValidObjectId(value) ? value : null);

  payload.addressId = toObjectIdOrNull(payload.addressId);
  payload.addressDestinationId = toObjectIdOrNull(payload.addressDestinationId);
  payload.contract_id = toObjectIdOrNull(payload.contract_id);
  payload.contentCategory = toObjectIdOrNull(payload.contentCategory);

  if (payload.type === "unknown") {
    payload.type = "unknown";
  }

  return payload;
}

export function validateZoneWizardStep(stepId, formData, t) {
  if (stepId === "contenant") {
    if (!isValidObjectId(formData.addressId)) {
      return {
        valid: false,
        message: t("settingsContainers.attachmentSiteRequired"),
      };
    }
    if (!formData.type || formData.type === "unknown") {
      return {
        valid: false,
        message: t("settingsContainers.containerTypeRequired"),
      };
    }
    if (!formData.volume || formData.volume <= 0) {
      return {
        valid: false,
        message: t("containerSettings.pleaseVolumeOrDimensions"),
      };
    }
    if (!isValidObjectId(formData.contentCategory)) {
      return {
        valid: false,
        message: t("settingsContainers.flowRequired"),
      };
    }
    const level = Number(formData.limitFillingLevel);
    if (!Number.isFinite(level) || level < 0 || level > 100) {
      return {
        valid: false,
        message: t("settingsContainers.criticalFillingRequired"),
      };
    }
    const allowed = ["drop_driver", "remove_driver_exchange", "collect"];
    if (!allowed.includes(formData.status)) {
      return {
        valid: false,
        message: t("settingsContainers.statusRequired"),
      };
    }
    return { valid: true };
  }

  return { valid: true };
}

export function validateAllZoneWizardSteps(formData, t) {
  return validateZoneWizardStep("contenant", formData, t);
}
